import { render, staticRenderFns } from "./NameAndTitle.vue?vue&type=template&id=0f62786e&"
var script = {}
import style0 from "./NameAndTitle.vue?vue&type=style&index=0&id=0f62786e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports